<template>
  <figure
    :style="productFigureHeight"
    class="b-image-wrapper image large"
  >
      <div
        style="overflow: hidden;"
        @mouseover.stop="showThumbBack"
        @mouseleave="showThumbFront"
      >

        <transition name="fade-image">
          <img
            ref="productImage"
            :src="productImage"
            :key="productImage"
            @load="productImageLoad"
          />

        </transition>
      </div>
  </figure>
</template>

<script>
  export default {
    name: 'LCProductFrontBack',
    data() {
      return {
        productFigureHeight: {
          overflow: 'hidden',
          height: 'auto'
        },
        productImage: this.front
      }
    },
    props: {
      front: {
        type: String,
        default: undefined
      },
      back: {
        type: String,
        default: undefined
      }
    },
    methods: {
      productImageLoad() {
        if (this.productFigureHeight.height == 'auto') {
          this.productFigureHeight.height = this.$refs.productImage.clientHeight + "px"
        }
      },
      showThumbBack() {
        this.productImage = this.back
      },
      showThumbFront() {
        this.productImage = this.front
      }
    }
  }
</script>

<style lang="scss" scoped>
.fade-image-enter-active, .fade-image-leave-active {
  transition: opacity .5s;
}

.fade-image-leave,
.fade-image-enter-to {
    position: relative;
    opacity: 1;
}

.fade-image-enter,
.fade-image-leave-to {
    position: absolute;
    opacity: 0;
}
</style>
